import * as React from "react";
 
// importing material UI components
import { useState } from 'react';
import WhatsAppMessageTable from './WhatsAppMessageTable';
import Container from '@mui/material/Container';
import {
  Grid,
  Button,
  Typography
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const WhatsAppMessage = (props) => { 
  
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 20
  });
  const [lastSynced, setLastSynced] = useState(null);

  const handleRefresh = () => {
    setController({
      page: 0,
      rowsPerPage: 20
    });
  };


  return (
    <div className="App">
      {/* <Header WhatsAppMessageState={props.WhatsAppMessageState}/> */}
      <Container maxWidth={false}>
        {/* <p>State: {props.WhatsAppMessageState} Time remaining: {props.remaining}</p> */}

        <Grid container alignItems="center" sx={{ mb: 2 }}>
          <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <h2 className="heading-title">Chat Logs</h2>
          </Grid>
          
          <Grid item xs={6} sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="contained" onClick={handleRefresh}>
              <RefreshIcon sx={{ mr: 1 }} /> Sync
            </Button>
          </Grid>
          
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            {lastSynced && (
              <Typography 
                variant="body2" 
                gutterBottom
                color="text.secondary"
              >
                Last Synced: {lastSynced}
              </Typography>
            )}
          </Grid>
        </Grid>

        <WhatsAppMessageTable 
          key={props.refreshKey} 
          controller={controller}
          setController={setController}
          lastSynced={lastSynced}
          setLastSynced={setLastSynced}
        />

      </Container>
    </div>
  );
}
export default WhatsAppMessage;
